// Mock account data. The engine has no concept of "who is playing" —
// seat 0 vs seat 1 is just indices — so names/factions/flavor labels
// live purely on the UI side for now. Once accounts land (M7+) this
// module goes away and the data comes from the server.

export interface PlayerIdentity {
  name: string;
  /** Faction key matching the `FACTIONS` dict (`humans`, `goblins`, …). */
  faction: string;
}

export const YOU: PlayerIdentity = {
  name: "Seren of the Carding Society",
  faction: "humans",
};

export const OPPONENT: PlayerIdentity = {
  name: "Zarvik Three-Fuse",
  faction: "goblins",
};
